import React from "react";
import aboutimg1 from "../assets/img/about_image.png";

import { Link } from "react-router-dom";

export const About = () => {
  return (
    <>
      <div className="about-container">
        <div className="about-div1">
          <div className="content-div1">
            <h3>About Us</h3>
            <h5>Leading Exporters From India</h5>
            <p>
            Welcome to Earthy Fusion Private Limited, your trusted exporter of high-quality agricultural commodities from India. Earthy Fusion Private Limited has rapidly emerged as a key player in India's agro commodity export market. The company has demonstrated impressive growth in turnover, thanks to its focus on quality, sustainability, and strong relationships with both Indian farmers and global buyers. Earthy Fusion specializes in exporting a diverse range of agro products, including grains, pulses, spices, fruits, and vegetables. By ensuring strict quality control and adhering to international standards, the company has quickly gained the trust of customers worldwide. The company is deeply committed to supporting sustainable farming practices and providing fair compensation to Indian farmers, ensuring a reliable and ethical supply chain. With efficient logistics and a focus on timely delivery, Earthy Fusion is making its mark on the global stage, showcasing the richness of India’s agricultural products to the world.
            </p>
            <Link to='/aboutus' className="btn btn-readmore">
              Read More
            </Link>
          </div>
          <div className="img-div1">
            <img src={aboutimg1} alt="about image1" />
          </div>
        </div>
      </div>
      {/* <div className='mission'>
        <div className='mission-img'>
          <img src={missionimage} alt='Mission Image' />

        </div>
        <div className='mission-content'>
          <h2>Our Mission</h2>
          <p>At G Educonnect, we are dedicated to empowering students and educational institutions to achieve their full potential. We strive to provide tailored guidance, innovative solutions, and comprehensive support in navigating the complexities of education. Our mission is to foster a passion for learning, enhance academic success, and promote lifelong growth through personalized consultancy services that inspire and transform. Together, we can build brighter futures.</p>
        </div>
      </div>
      <div className='vision'>

        <div className='vision-content'>
          <h2>Our vision</h2>
          <p>Our vision is to turn knowledge into value for the benefit of students. Our innovative spirit inspires what we do and how we do it. Constantly striving to be better lies at the heart of what makes us different. We are committed to maintaining the highest standards of integrity and professionalism in our relationship with our partner institutions and students. We strive to know and understand the educational and financial background of students to provide them with only the highest quality advice and information in reaching their goals.</p>
        </div>
        <div className='vision-img'>
          <img src={vissionimage} alt='vission Image' />

        </div>
      </div>

      <div className='why-container'>
        <div className='why-image'>
          <img src={whyusimage} alt='Mission Image' />

        </div>
        <div className='why-content'>
          <li><img src={whyicon} alt='Why icon' /><p><b>Personalized Approach: </b>We understand that every student and institution has unique needs. Our tailored solutions ensure that you receive the specific guidance and support necessary to achieve your educational goals.</p></li>
          <li><img src={whyicon} alt='Why icon' /><p><b>Expertise and Experience: </b>Our team consists of seasoned education professionals with extensive experience in various academic fields. We stay up-to-date with the latest trends and best practices to provide you with informed advice.</p></li>
          <li><img src={whyicon} alt='Why icon' /><p><b>Comprehensive Services: </b>From college admissions and career counseling to curriculum development and training programs, we offer a wide range of services designed to support students and educational institutions at every stage.</p></li>
          <li><img src={whyicon} alt='Why icon' /><p><b>Proven Track Record: </b>We take pride in our successful track record. Our clients consistently achieve their academic goals, and our methods have helped countless students and institutions thrive.</p></li>
          <li><img src={whyicon} alt='Why icon' /><p><b>Strong Network: </b>With established connections to schools, universities, and educational organizations, we provide you with invaluable resources and opportunities that can enhance your educational journey.</p></li>
          <li><img src={whyicon} alt='Why icon' /><p><b>Commitment to Excellence</b>Our passion for education drives us to go above and beyond for our clients. We are dedicated to providing high-quality services and support that make a real difference.</p></li>
          <li><img src={whyicon} alt='Why icon' /><p><b>Supportive Community: </b>When you choose us, you join a community that values collaboration, encouragement, and growth. We believe in building lasting relationships that foster ongoing success.</p></li>
        </div>
      </div>

      <OurTeam /> */}
    </>
  );
};
